import { c as _c } from "react/compiler-runtime";
import PWAInstallButton from "@/components/PWAInstallButton";
import { SignedIn, SignedOut, SignInButton, UserButton } from "@clerk/nextjs";
import * as motion from "motion/react-client";
import Image from "next/image";
import { MobileMenu } from "./MobileMenu";
export const Header = () => {
  const $ = _c(10);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0
    };
    t1 = {
      opacity: 1
    };
    t2 = {
      duration: 0.5
    };
    t3 = {
      once: true
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="relative h-6 w-6"><Image src="/icon.png" alt="Logo" fill={true} sizes="24px" priority={true} /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex items-center"><a href="/home" className="flex items-center">{t4}<div className="-mr-16"><h1 className="bg-gradient-to-r from-blue-400 to-purple-600 bg-clip-text text-2xl font-bold text-transparent inline">PsxWorth<span className="text-sm bg-inherit bg-clip-text text-transparent">.com</span></h1></div></a></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <nav className="hidden md:block"><ul className="flex space-x-8"><li><a href="/portfolio" className="transition-colors hover:text-purple-400">Portfolio</a></li><li><a href="/faqs" className="transition-colors hover:text-purple-400">FAQs</a></li><li><a href="/contact" className="transition-colors hover:text-purple-400">Contact</a></li></ul></nav>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <PWAInstallButton />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SignedOut><SignInButton mode="modal" /></SignedOut>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <header className="mx-auto min-h-16 pt-4 max-w-7xl px-3  md:px-12"><motion.div className="flex items-center justify-between" initial={t0} animate={t1} transition={t2} viewport={t3}>{t5}{t6}<div className="flex gap-1 items-center">{t7}<div className="flex justify-center items-center w-14 h-12">{t8}<SignedIn><UserButton /></SignedIn>{" "}</div><MobileMenu /></div></motion.div></header>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
};